import { create } from 'zustand';

const useLanguagesStore = create((set) => ({
    language: 'en',
    select: false,
    dict: {},
    setLanguage: (newLanguage) => {
        set({ language: newLanguage });
        if (typeof window !== 'undefined') {
            localStorage.setItem('language', newLanguage);
        }
    },
    toggleSelect: (newSelected) => set({ select: newSelected }),
    setDict: (newDict) => set({ dict: newDict }),
}));

export default useLanguagesStore;
